import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import {
  CompanyCreate,
  companyCreateSchema,
} from "@/schema/console/companies/CompanyCreate";
import CompanyForm from "@/src/console/(auth)/companies/new/_components/CompanyForm";
import CompanyFormActionButtons from "@/src/console/(auth)/companies/new/_components/CompanyFormActionButtons";
import { zodResolver } from "@hookform/resolvers/zod";
import { format } from "date-fns";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function New() {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: t("companies"),
      href: "/console/companies",
    },
    {
      name: t("new"),
      href: "/console/companies/new",
    },
  ];

  const methods = useForm<CompanyCreate>({
    resolver: zodResolver(companyCreateSchema),
    defaultValues: {
      established_date: format(new Date(), "yyyy-MM-dd"),
    },
  });

  return (
    <>
      <FormProvider {...methods}>
        <AdminNavbar breadcrumbs={breadcrumbs} />
        <CompanyForm />
        <CompanyFormActionButtons />
      </FormProvider>
    </>
  );
}

export default New;
